<template>
    <div>
        <v-card flat tile class="ma-3 pa-3">
            <v-card-text>
                <div class="text-center">
                    <v-btn large color="primary" @click="reset">Reset All</v-btn>
                </div>
                <v-divider class="my-3"></v-divider>
                <div class="text-center">
                    <div class="subheading">Click to reset individual sections</div>
                    <div class="caption">Click 'Home' after resetting one or more sections</div>
                    <div class="caption">Darkened sections have been completed</div>
                    <v-btn class="ma-1" large v-for="module in modules" :key="module.id" :class="{ primary: isComplete(module) }" @click="resetModule(module)">{{ module.id }}</v-btn>
                    <div class="mt-3">
                        <v-btn large color="primary" @click="home">Home</v-btn>
                    </div>
                </div>
            </v-card-text>
        </v-card>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </div>
</template>

<script>
    import router from '@/router';
    import { get } from 'vuex-pathify';
    import { clone, find, reverse } from 'lodash';

    export default {
        name: 'Reset',
        computed: {
            modules: get('content@modules'),
            completedModules: get('completed')
        },
        methods: {
            reverse(arr) {
                return reverse(clone(arr));
            },
            isComplete(module) {
                return find(this.completedModules, { id: module.id });
            },
            reset() {
                this.$api.delete('/reset').then(() => {
                    window.location.href = '/';
                });
            },
            resetModule(module) {
                this.$store.commit('resetModule', module);
                this.$refs.modalFeedback.show(true, `Module ${module.id} (${module.title}) has been reset`);
            },
            home() {
                router.push('/');
            }
        }
    };
</script>
